import Image from "next/image";
import { useState } from "react";

interface ProductImageProps {
  src: string;
  alt: string;
  className?: string;
}

const ProductImage = ({ src, alt, className }: ProductImageProps) => {
  const [imgSrc, setImgSrc] = useState(src);

  const handleImageError = () => {
    setImgSrc("/img/No_Image.jpg");
  };

  return (
    <Image
      src={imgSrc}
      alt={alt}
      layout="fill"
      objectFit="contain"
      onError={handleImageError}
      className={className}
    />
  );
};

export default ProductImage;
